export const MODULE_NAME = 'user';
export default {};
